import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {CaptionManager} from "./CaptionManager";

type Callback = (pDidPlay: boolean) => void;

export class VoiceOverManager {

    static get instance() {
        return this._instance || (this._instance = new VoiceOverManager());
    }

    public get active() {
        return this.ccManager.active ||
            (this.audioManager.masterVolume !== 0 && this.audioManager.getCategoryVolume(HLF.AudioCategory.VO) !== 0);
    }

    private static _instance: VoiceOverManager;

    private readonly audioManager = Application.instance.audio;
    private readonly voManager = Application.instance.voiceover;
    private readonly ccManager = CaptionManager.instance;

    public playVO(
        key: string | Array<string | number>,
        mode?: HLF.PlayMode | Callback | HLF.IPlayOptions,
        callback?: Callback,
    ) {
        if (!this.active) {
            let originalCallback: Callback | undefined;
            if (typeof callback === "function") {
                originalCallback = callback;
            } else if (typeof mode === "function") {
                originalCallback = mode;
            } else if (typeof mode === "object" && mode.callback) {
                originalCallback = mode.callback;
            }
            if (originalCallback) {
                window.setTimeout(() => {
                    originalCallback!(false);
                }, 10);
            }
        } else {
            this.voManager.playVO(key, mode as any, callback as any);
        }
    }

    public stopVO() {
        this.voManager.stopVO();
    }
}
